module.exports = __webpack_public_path__ + "static/media/vault_grey.2d7cf9d2.png";